import { render, staticRenderFns } from "./MembershipRoute.vue?vue&type=template&id=098b1753&"
import script from "./MembershipRoute.vue?vue&type=script&lang=ts&"
export * from "./MembershipRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports